import {ElectronicsCCActionType} from '../ActionType'
import { Dispatch } from 'redux'

/**
 * @typedef Locale Init
 * @returns noting
 * @author IOTA IT
 * @version 0.0.1
 */
export const ElectronicsCCRequestInit = () => {
    return {
        type: ElectronicsCCActionType.ElectronicsCC_INIT
    }
}

export const ElectronicsCCSuccess = (
    objeckt: any
) => {
    return {
        type: ElectronicsCCActionType.ElectronicsCC_INIT,
        objeckt: objeckt
    }
}

export const getElectronicsCC = (
    objeckt: any[]
) => {
    return (dispatch: Dispatch) => {
        dispatch(
            ElectronicsCCSuccess(
                objeckt
            )
        )
    }
}
